export default "__VITE_ASSET__CQCEzenU__"